import React from 'react';

const Header = props => (
  <header className= "pda-modal-header">
    {props.title}
  </header>
)

const Footer = props => (
  <div className="pda-modal-footer">
    {props.children}
  </div>

)

const Body = props => (
  <section className="pda-modal-body">
    {props.children}
  </section>
)

const Modal = props => {
  return (
    <div className="pda-modal">
      { props.children }
    </div>
  )
}

Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;


export default Modal;
